/** Asset 360 / Site 360 (tracker 39), under assets:report360. See locales/en-US/report360.ts. */
export const report360 = {
  ui: {
    finding: "Constat",
    versionPrepared: "Version {{version}} · préparée le {{date}}",
    kindAsset: "Asset 360",
    kindSite: "Site 360",
    kindVersion: "{{kind}} · version {{version}}",
    preparedFor: "Préparé pour {{name}}",
    writtenFor: "Rédigé pour : {{reader}}",
    prepared: "Préparé le {{date}}",
    figuresAsOf: "chiffres au {{date}}",
    wordsByAi: "Explications rédigées par l'IA (Google Gemini) à partir des chiffres de l'application. L'IA ne modifie jamais un chiffre.",
    wordsByApp: "Rédigé par l'application à partir de vos données.",
    verdictTitle: "Avis général",
    contents: "Sommaire",
    contentsLine: "{{number}}. {{title}}",
    contentsTail: "Ensuite : plan d'action, qualité des données, à propos de ce rapport.",
    summaryTitle: "Synthèse",
    keyFindings: "Constats principaux",
    doFirst: "À faire en premier",
    bullet: "• {{text}}",
    scorecardTitle: "Tableau de bord",
    noData: "Pas encore de données",
    change30d: "{{value}} en 30 jours",
    sectionTitle: "{{number}}. {{title}}",
    whatItMeans: "Ce que cela signifie",
    actionsTitle: "Plan d'action",
    actionsNone: "Rien à faire pour le moment.",
    priority1: "Tout de suite",
    priority2: "Ensuite",
    priority3: "Dès que possible",
    due_one: "Sous {{count}} jour",
    due_other: "Sous {{count}} jours",
    due_many: "Sous {{count}} jours",
    raiseJob: "Créer une intervention",
    raiseInspection: "Lancer une inspection",
    open: "Ouvrir",
    dataQualityTitle: "Qualité des données",
    dataQualityIntro: "Dans quelle mesure ce rapport peut s'appuyer sur vos données. Les lacunes réduisent la fiabilité de chaque section.",
    cannotJudge: "Ce que le rapport n'a pas pu évaluer",
    getMoreTitle: "Tirer davantage de ce rapport",
    getMoreIntro: "Vous seul voyez ceci. Ce n'est jamais inclus dans ce que vous partagez.",
    aboutTitle: "À propos de ce rapport",
    coverage: "{{recorded}} types de données sur {{total}} sont renseignés.",
    coverageMissing: "Pas encore renseigné : {{list}}.",
    aboutAsset_one: "Les scores proviennent des chiffres de la nuit ; les interventions et inspections couvrent le dernier {{count}} jour.",
    aboutAsset_other: "Les scores proviennent des chiffres de la nuit ; les interventions et inspections couvrent les {{count}} derniers jours.",
    aboutAsset_many: "Les scores proviennent des chiffres de la nuit ; les interventions et inspections couvrent les {{count}} derniers jours.",
    aboutSite_one: "Les scores proviennent de la synthèse nocturne du site ; les interventions couvrent le dernier {{count}} jour.",
    aboutSite_other: "Les scores proviennent de la synthèse nocturne du site ; les interventions couvrent les {{count}} derniers jours.",
    aboutSite_many: "Les scores proviennent de la synthèse nocturne du site ; les interventions couvrent les {{count}} derniers jours.",
    aboutAi: "L'IA a rédigé la synthèse et les explications pour le lecteur choisi. Chaque chiffre, note et constat vient de l'application.",
    highRisk: "risque élevé",
    nothingToShow: "Rien à afficher pour le moment.",
    labelValue: "{{label}} : {{value}}",
    whereItSits: "Emplacement",
    dependsOn: "Dépend de",
    serves: "Alimente",
    none: "Rien d'enregistré",
    singlePoints: "Point de défaillance unique : {{names}}",
    hiddenLinks_one: "{{count}} autre lien que vous ne pouvez pas ouvrir",
    hiddenLinks_other: "{{count}} autres liens que vous ne pouvez pas ouvrir",
    hiddenLinks_many: "{{count}} autres liens que vous ne pouvez pas ouvrir",
    prepareTitle: "Préparer le rapport",
    readerLabel: "Pour qui est-il ?",
    readerA11y: "Rédiger le rapport pour : {{reader}}",
    hideNames: "Masquer le nom des prestataires",
    hideNamesHint: "Affiche les prestataires comme Prestataire A, B, etc.",
    preparedForLabel: "Préparé pour (facultatif)",
    preparedForPlaceholder: "Par exemple, Foncière du Port SA",
    storyTitle: "Version IA",
    storyHint: "Google Gemini réécrit la synthèse et chaque explication pour votre lecteur, dans la langue choisie. Il ne modifie jamais un chiffre.",
    languageLabel: "Langue",
    focusLabel: "Points d'attention de l'IA",
    pickFocus: "Choisissez au moins une section sur laquelle l'IA doit se concentrer.",
    weakData: "La qualité des données est faible ({{score}} sur 100). L'IA dira ce qu'elle ne peut pas évaluer plutôt que de deviner.",
    generate: "Rédiger la version IA",
    chargedWhenWritten: "Le crédit n'est prélevé qu'une fois le rapport rédigé. En cas d'échec, rien n'est facturé.",
    queuedTitle: "Votre version IA est en file d'attente",
    queuedBody: "Position {{position}} dans la file. Vous pouvez quitter cette page : vous recevrez une notification quand elle sera prête.",
    runningTitle: "Rédaction de votre version IA…",
    runningBody: "Cela prend généralement moins d'une minute. Vous pouvez quitter cette page : vous recevrez une notification quand elle sera prête.",
    failedTitle: "La version IA n'a pas pu être rédigée",
    failedBody: "Rien n'a été facturé. Réessayez dans un instant.",
    joined: "Quelqu'un a déjà demandé ce rapport ; vous recevrez tous les deux le même.",
    showingAi: "Version IA {{version}}, rédigée le {{date}}",
    showingApp: "Version de l'application pour ce lecteur",
    showApp: "Afficher la version de l'application",
    showAi: "Afficher la version IA",
    loading: "Préparation du rapport…",
    loadFailed: "Le rapport n'a pas pu être ouvert.",
    busy: "Les rapports sont très sollicités. Réessayez dans un instant.",
    retry: "Réessayer",
    requestFailedTitle: "Impossible de demander la version IA",
    earlierTitle: "Avant Asset 360",
    earlierHint: "Rapports IA rédigés avant Asset 360 et Site 360. Touchez une date pour le lire.",
    shareTitle: "{{kind}} : {{name}}",
  },
  reader: {
    asset_manager: "Gestionnaire d'actifs",
    client: "Client",
    landlord: "Propriétaire",
    site_manager: "Responsable de site",
    investor: "Investisseur",
  },
  readerHint: {
    asset_manager: "La vue complète, de l'environnement jusqu'aux interventions, avec toutes les sections.",
    client: "Interventions et prestataires d'abord : ce qui a été fait, avec quelle qualité et dans quels délais.",
    landlord: "Conformité et risque d'abord. Le nom des prestataires est masqué, sauf si vous l'affichez.",
    site_manager: "Interventions et état d'abord, avec le plan d'action juste après la synthèse.",
    investor: "Environ deux pages : avis général, tableau de bord, risque, conformité et principales actions.",
  },
  rating: {
    on_track: "Conforme aux attentes",
    watch: "À surveiller",
    needs_attention: "Action requise",
  },
  confidence: {
    high: "Fiabilité : élevée",
    medium: "Fiabilité : moyenne",
    low: "Fiabilité : faible",
  },
  dqBand: {
    strong: "Bonne",
    fair: "Moyenne",
    weak: "Faible",
  },
  dimension: {
    complete: "Complètes",
    current: "À jour",
    evidenced: "Justifiées",
    connected: "Reliées",
    consistent: "Cohérentes",
  },
  scorecard: {
    asset: {
      compliance: "Conformité",
      risk: "Risque",
      condition: "État",
      inspections_on_time: "Inspections à l'heure",
      right_first_time: "Réussi du premier coup",
      overdue_work: "Interventions en retard",
    },
    site: {
      compliance: "Conformité",
      risk: "Risque moyen",
      condition: "État",
      inspections_on_time: "Actifs inspectés cette année",
      right_first_time: "Réussi du premier coup",
      overdue_work: "Interventions en retard",
    },
  },
  section: {
    environment: "Emplacement et environnement",
    compliance: "Conformité",
    risk: "Risque",
    condition: "État et inspections",
    work: "Interventions",
    contractors: "Prestataires",
    property: "Le bien",
    areas: "Bâtiments et zones",
    inspections: "Inspections",
    siteRisk: "Risque sur l'ensemble du site",
  },
  finding: {
    environment: {
      noSite: "Il n'est rattaché à aucun site, son environnement est donc inconnu.",
      site: "Il se trouve sur le site {{site}}, où {{atRisk}} actifs sur {{assets}} sont à risque et {{overdue}} interventions sont en retard.",
      siteNoSummary: "Il se trouve sur le site {{site}}, qui n'a pas encore de synthèse nocturne.",
    },
    compliance: {
      expired_one: "Un certificat ou document a expiré.",
      expired_other: "{{count}} certificats ou documents ont expiré.",
      expired_many: "{{count}} certificats ou documents ont expiré.",
      expiring_one: "Un certificat expire dans les 60 prochains jours.",
      expiring_other: "{{count}} certificats expirent dans les 60 prochains jours.",
      expiring_many: "{{count}} certificats expirent dans les 60 prochains jours.",
      noDocuments: "La conformité est de {{score}}, mais aucun certificat n'est enregistré pour la justifier.",
      noFigures: "Aucun chiffre de conformité n'est encore enregistré.",
      ok_one: "La conformité est de {{score}}, avec {{count}} document enregistré et rien d'expiré.",
      ok_other: "La conformité est de {{score}}, avec {{count}} documents enregistrés et rien d'expiré.",
      ok_many: "La conformité est de {{score}}, avec {{count}} documents enregistrés et rien d'expiré.",
      site: "La conformité sur l'ensemble du site est de {{score}}.",
      siteExpired_one: "Un document a expiré sur le site.",
      siteExpired_other: "{{count}} documents ont expiré sur le site.",
      siteExpired_many: "{{count}} documents ont expiré sur le site.",
    },
    condition: {
      health: "L'état est de {{score}} ({{band}}). Jours depuis la dernière inspection : {{days}}.",
      inspected: "Aucun score d'état n'est encore enregistré. Jours depuis la dernière inspection : {{days}}.",
      neverInspected: "Il n'a jamais été inspecté, son état actuel est donc inconnu.",
      overdueChecks_one: "Un contrôle planifié est en retard.",
      overdueChecks_other: "{{count}} contrôles planifiés sont en retard.",
      overdueChecks_many: "{{count}} contrôles planifiés sont en retard.",
    },
    contractors: {
      none: "Aucun prestataire n'est intervenu ici sur cette période.",
      summary_one: "Un prestataire a réalisé {{jobs}} interventions : {{busiest}}.",
      summary_other: "{{count}} prestataires ont réalisé {{jobs}} interventions. Le plus actif est {{busiest}}.",
      summary_many: "{{count}} prestataires ont réalisé {{jobs}} interventions. Le plus actif est {{busiest}}.",
    },
    inspections: {
      noSummary: "Aucune synthèse d'inspection n'est encore enregistrée pour ce site.",
      site: "{{inspected}} actifs sur {{assets}} ont été inspectés cette année. {{failed}} inspections sur {{inspections}} des 90 derniers jours ont relevé des problèmes.",
    },
    property: {
      noSummary: "Le site compte {{assets}} actifs. Aucune synthèse nocturne n'est encore enregistrée.",
      summary: "Le site compte {{assets}} actifs. {{atRisk}} sont à risque et {{open}} interventions sont ouvertes.",
    },
    risk: {
      level: "Le risque est {{level}} ({{score}} sur 25).",
      neighbours_one: "Le risque est {{level}} ({{score}} sur 25), et un actif lié présente un risque élevé.",
      neighbours_other: "Le risque est {{level}} ({{score}} sur 25), et {{count}} actifs liés présentent un risque élevé.",
      neighbours_many: "Le risque est {{level}} ({{score}} sur 25), et {{count}} actifs liés présentent un risque élevé.",
      notAssessed: "Aucune évaluation des risques n'a été réalisée.",
      singlePoint: "Le risque est {{level}} ({{score}} sur 25), et {{name}} est un point de défaillance unique.",
      site: "Le risque moyen est {{level}} ({{score}} sur 25). {{atRisk}} actifs sont à risque.",
      siteNotAssessed: "Les actifs du site n'ont pas fait l'objet d'une évaluation des risques.",
    },
    work: {
      none: "Aucune intervention n'a été créée au cours des 12 derniers mois.",
      ok: "{{done}} interventions ont été réalisées au cours des 12 derniers mois, aucune en retard ni renvoyée.",
      overdue_one: "Une intervention est en retard. {{done}} interventions ont été réalisées au cours des 12 derniers mois.",
      overdue_other: "{{count}} interventions sont en retard. {{done}} interventions ont été réalisées au cours des 12 derniers mois.",
      overdue_many: "{{count}} interventions sont en retard. {{done}} interventions ont été réalisées au cours des 12 derniers mois.",
      rework_one: "Une intervention terminée sur {{done}} a été renvoyée ({{pct}} % réussies du premier coup).",
      rework_other: "{{count}} interventions terminées sur {{done}} ont été renvoyées ({{pct}} % réussies du premier coup).",
      rework_many: "{{count}} interventions terminées sur {{done}} ont été renvoyées ({{pct}} % réussies du premier coup).",
      siteNone: "Aucune intervention n'a été créée sur les actifs du site au cours des 90 derniers jours.",
      siteOk: "{{done}} interventions ont été réalisées au cours des 90 derniers jours et aucune n'a été renvoyée.",
      siteRework_one: "Une intervention terminée sur {{done}} a été renvoyée au cours des 90 derniers jours ({{pct}} % réussies du premier coup).",
      siteRework_other: "{{count}} interventions terminées sur {{done}} ont été renvoyées au cours des 90 derniers jours ({{pct}} % réussies du premier coup).",
      siteRework_many: "{{count}} interventions terminées sur {{done}} ont été renvoyées au cours des 90 derniers jours ({{pct}} % réussies du premier coup).",
    },
    areas: {
      none: "Aucun bâtiment ni zone n'est enregistré sur le site. Sites qu'il contient : {{n}}.",
      summary_one: "Un bâtiment ou une zone est enregistré ; {{top}} contient {{assets}} actifs.",
      summary_other: "{{count}} bâtiments et zones sont enregistrés. Le plus grand, {{top}}, contient {{assets}} actifs.",
      summary_many: "{{count}} bâtiments et zones sont enregistrés. Le plus grand, {{top}}, contient {{assets}} actifs.",
    },
  },
  meaning: {
    environment: {
      noSite: "Sans site, le rapport ne peut pas dire ce qui l'entoure ni ce qu'un problème à proximité signifierait pour lui.",
      ok: "Son environnement est en bon état, un problème ici a donc peu de chances d'être aggravé par ce qui l'entoure.",
      siteWeak: "Le site présente des problèmes non résolus. Des travaux à proximité peuvent le perturber, et ses propres défauts pèsent davantage.",
      neighboursRisk_one: "Un actif auquel il est lié présente un risque élevé : une défaillance là-bas pourrait l'atteindre.",
      neighboursRisk_other: "{{count}} actifs auxquels il est lié présentent un risque élevé : une défaillance là-bas pourrait l'atteindre.",
      neighboursRisk_many: "{{count}} actifs auxquels il est lié présentent un risque élevé : une défaillance là-bas pourrait l'atteindre.",
    },
    compliance: {
      on_track: "Les documents sont en ordre. Renouvelez à temps et cela restera ainsi.",
      watch: "La conformité se dégrade. Renouvelez ce qui arrive à échéance avant que cela ne soit relevé.",
      needs_attention: "La conformité exige une action immédiate : un contrôleur ou un assureur le relèverait.",
      none: "Il n'y a pas encore de chiffres de conformité pour en juger.",
      expired: "Un certificat expiré peut rendre son utilisation illégale ou non assurée jusqu'à son renouvellement.",
      noDocuments: "Sans document enregistré, le score ne peut être justifié auprès de personne.",
      awaitingCheck_one: "Un document attend d'être vérifié, il ne compte donc pas encore.",
      awaitingCheck_other: "{{count}} documents attendent d'être vérifiés, ils ne comptent donc pas encore.",
      awaitingCheck_many: "{{count}} documents attendent d'être vérifiés, ils ne comptent donc pas encore.",
    },
    risk: {
      on_track: "Le risque est faible. L'entretien courant et les contrôles planifiés suffisent.",
      watch: "Le risque est modéré. Tenez les contrôles à l'heure et surveillez l'évolution.",
      needs_attention: "Le risque est élevé. Une défaillance serait coûteuse ou dangereuse : suivez le plan ci-dessous.",
      notAssessed: "Sans évaluation des risques, personne ne peut dire quel serait l'impact d'une défaillance.",
      noLinks: "Le risque est {{level}}. Aucun lien avec d'autres actifs n'est enregistré, les effets en cascade sont donc inconnus.",
      singlePoint: "D'autres actifs en dépendent sans solution de secours : une défaillance ici les arrête aussi.",
    },
    condition: {
      on_track: "Il est en bon état et inspecté à l'heure.",
      watch: "Son état commence à se dégrader. Surveillez la prochaine inspection.",
      needs_attention: "Son état est mauvais. Prévoyez une réparation ou un remplacement.",
      none: "Il n'y a pas encore de score d'état enregistré pour en juger.",
      neverInspected: "Personne ne l'a examiné dans l'application : son état reste une supposition jusqu'à l'inspection.",
      issues_one: "Une inspection récente a relevé des problèmes à suivre.",
      issues_other: "{{count}} inspections récentes ont relevé des problèmes à suivre.",
      issues_many: "{{count}} inspections récentes ont relevé des problèmes à suivre.",
      repeat: "« {{item}} » revient sans cesse. Traiter la cause éviterait des déplacements répétés.",
    },
    work: {
      none: "Aucune intervention signifie soit qu'il n'y avait rien à faire, soit que les travaux ne sont pas enregistrés dans l'application.",
      ok: "Les interventions sont réalisées à l'heure et réussies du premier coup.",
      overdue: "Les interventions en retard laissent des problèmes connus sans solution et augmentent le risque.",
      rework: "Les interventions renvoyées coûtent un second déplacement et retardent la réparation.",
    },
    contractors: {
      none: "Aucun travail de prestataire n'est enregistré, leurs performances ne peuvent donc pas être évaluées.",
      good: "Les prestataires finissent à l'heure et réussissent du premier coup.",
      late_one: "Un prestataire termine souvent en retard.",
      late_other: "{{count}} prestataires terminent souvent en retard.",
      late_many: "{{count}} prestataires terminent souvent en retard.",
      sentBack_one: "Un prestataire a vu des travaux renvoyés.",
      sentBack_other: "{{count}} prestataires ont vu des travaux renvoyés.",
      sentBack_many: "{{count}} prestataires ont vu des travaux renvoyés.",
      offApp_one: "Un prestataire n'utilise pas l'application, ses travaux sont donc moins justifiés.",
      offApp_other: "{{count}} prestataires n'utilisent pas l'application, leurs travaux sont donc moins justifiés.",
      offApp_many: "{{count}} prestataires n'utilisent pas l'application, leurs travaux sont donc moins justifiés.",
    },
    property: {
      on_track: "Le bien est globalement en bon état.",
      watch: "Le bien est en grande partie en ordre, avec quelques points à surveiller.",
      needs_attention: "Le bien demande une action : la conformité ou l'état est en dessous du niveau attendu.",
      truncated: "Ce site compte {{n}} actifs ; le rapport lit les 5 000 premiers.",
    },
    areas: {
      none: "Sans bâtiments ni zones, le rapport ne peut pas montrer où les problèmes se concentrent.",
      ok: "Aucun bâtiment ni aucune zone ne se distingue comme problématique.",
      highRisk: "Les actifs à risque élevé se concentrent dans {{area}}. Commencez par là.",
    },
    inspections: {
      on_track: "Presque tous les actifs ont été inspectés cette année.",
      watch: "Certains actifs n'ont pas été inspectés cette année.",
      needs_attention: "De nombreux actifs n'ont pas été inspectés cette année, leur état est donc inconnu.",
      none: "Il n'y a pas encore de synthèse d'inspection pour en juger.",
      overdue: "Des contrôles planifiés sont en retard. Rattrapez-les avant que des problèmes ne passent inaperçus.",
    },
  },
  basis: {
    environment: {
      summary: "D'après la synthèse nocturne du site du {{date}}.",
      noSummary: "D'après la fiche du site ; le site n'a pas encore de synthèse nocturne.",
    },
    site: {
      summary: "D'après la synthèse nocturne du {{date}}.",
    },
    compliance: "D'après les chiffres de la nuit et les documents enregistrés ({{n}}).",
    risk: "D'après la dernière évaluation des risques et les liens avec d'autres actifs ({{links}}).",
    condition: "D'après les chiffres d'état de la nuit et les inspections récentes ({{n}}).",
    work: {
      year: "D'après les interventions des 12 derniers mois ({{n}}).",
      ninetyDays: "D'après les interventions des 90 derniers jours ({{n}}).",
    },
    contractors: {
      year: "D'après les interventions de prestataires des 12 derniers mois ({{n}}).",
      ninetyDays: "D'après les interventions de prestataires des 90 derniers jours ({{n}}).",
    },
    areas: "D'après les emplacements enregistrés sur le site et les actifs qu'ils contiennent ({{n}}).",
    siteRisk: "D'après les évaluations des risques des actifs du site ({{n}}).",
  },
  score: {
    compliance: {
      on_track: "Rien à signaler : documents en ordre.",
      watch: "Certains documents à renouveler ou manquants.",
      needs_attention: "Documents expirés ou manquants.",
      none: "Pas encore de chiffres.",
    },
    risk: {
      on_track: "Risque faible.",
      watch: "Risque modéré.",
      needs_attention: "Risque élevé.",
      none: "Non évalué.",
    },
    condition: {
      on_track: "Bon état.",
      watch: "État en baisse.",
      needs_attention: "Mauvais état.",
      none: "Pas encore de chiffres d'état.",
    },
    inspectionsOnTime: {
      on_track: "Contrôles planifiés réalisés à l'heure.",
      watch: "Quelques contrôles en retard.",
      needs_attention: "Beaucoup de contrôles en retard.",
      none: "Aucun contrôle planifié.",
    },
    inspectedThisYear: {
      on_track: "Presque tous les actifs inspectés cette année.",
      watch: "Certains actifs non inspectés cette année.",
      needs_attention: "De nombreux actifs non inspectés cette année.",
      none: "Pas encore de synthèse d'inspection.",
    },
    rightFirstTime: {
      on_track: "Travaux réussis du premier coup.",
      watch: "Quelques travaux renvoyés.",
      needs_attention: "Beaucoup de travaux renvoyés.",
      none: "Aucun travail terminé à évaluer.",
    },
    overdueWork: {
      on_track: "Rien en retard.",
      watch: "Interventions après échéance : {{n}}.",
      needs_attention: "Interventions après échéance : {{n}}.",
      none: "Aucune intervention enregistrée.",
    },
  },
  band: {
    posture: {
      on_track: "Rien à signaler",
      watch: "À surveiller",
      needs_attention: "Action",
    },
    risk: {
      low: "faible",
      medium: "moyen",
      high: "élevé",
      extreme: "extrême",
    },
  },
  verdict: {
    on_track: "Conforme aux attentes : {{reason}}",
    watch: "À surveiller : {{reason}}",
    needs_attention: "Action requise : {{reason}}",
    on_track_all: "Conforme aux attentes : tous les indicateurs sont bons.",
  },
  reason: {
    compliance: "la conformité est de {{value}}.",
    risk: "le risque est de {{value}} sur 25.",
    condition: "l'état est de {{value}}.",
    inspections_on_time: "{{value}} % des inspections sont à l'heure.",
    right_first_time: "{{value}} % des travaux sont réussis du premier coup.",
    overdue_work: "interventions après échéance : {{value}}.",
  },
  stat: {
    jobsWithSubJobs: "Travaux avec sous-tâches",
    familiesOnTime: "Dont à temps",
    waitBetweenSteps: "Attente entre étapes",
    stepsSentBack: "Étapes renvoyées",
    hoursValue: "{{n}} h",
    assets: "Actifs",
    assetsAtRisk: "Actifs à risque",
    checksDone: "Contrôles réalisés",
    checksNext60: "Contrôles dus sous 60 jours",
    checksOverdue: "Contrôles en retard",
    checksPlanned: "Contrôles planifiés",
    expiredDocuments: "Documents expirés",
    failed90d: "Inspections avec problèmes (90 jours)",
    inspectedThisYear: "Inspectés cette année",
    inspections90d: "Inspections (90 jours)",
    jobsDone: "Interventions réalisées",
    links: "Actifs liés",
    neighbours: "Actifs à proximité",
    onTime: "À l'heure",
    openJobs: "Interventions ouvertes",
    overdueJobs: "Interventions en retard",
    rejected: "Refusées",
    rescheduled: "Reprogrammées",
    rightFirstTime: "Réussi du premier coup",
    sentBack: "Renvoyées",
    siteAtRisk: "Actifs du site à risque",
    siteCompliance: "Conformité du site",
    siteHealth: "État du site",
    siteOverdueJobs: "Interventions en retard sur le site",
  },
  col: {
    area: "Zone",
    asset: "Actif",
    assets: "Actifs",
    avgDays: "Jours en moyenne",
    contractor: "Prestataire",
    date: "Date",
    document: "Document",
    expires: "Expire le",
    highRisk: "Risque élevé",
    issues: "Problèmes",
    job: "Intervention",
    jobs: "Interventions",
    kind: "Type",
    level: "Niveau",
    onTime: "À l'heure",
    reason: "Motif",
    result: "Résultat",
    risk: "Risque",
    sentBack: "Renvoyées",
    site: "Site",
    status: "Statut",
    usesApp: "Utilise l'application",
  },
  visual: {
    areas: "Bâtiments et zones",
    byZone: "Actifs par zone",
    childSites: "Sites dans ce site",
    complianceTrend: "Conformité, 90 derniers jours",
    contractors: "Prestataires",
    documents: "Documents",
    healthTrend: "État, 90 derniers jours",
    openJobsTrend: "Interventions ouvertes, 90 derniers jours",
    recentInspections: "Inspections récentes",
    repeatItems: "Défauts récurrents",
    rework: "Motifs de renvoi des travaux",
    riskTrend: "Risque, 90 derniers jours",
    topRisk: "Actifs les plus à risque",
  },
  docStatus: {
    awaitingCheck: "En attente de vérification",
    expired: "Expiré",
    expiring: "Expire bientôt",
    valid: "Valide",
  },
  result: {
    issues: "Problèmes relevés",
    passed: "Réussie",
    open: "Non terminée",
  },
  common: {
    yes: "Oui",
    no: "Non",
    noReason: "Aucun motif indiqué",
    noExpiry: "Sans expiration",
  },
  contractors: {
    anonymous: "Prestataire {{letter}}",
  },
  action: {
    planReplacement: "Planifier le remplacement de {{name}}",
    backup: "Prévoir une solution de secours pour {{name}}",
    clearOverdue_one: "Traiter l'intervention en retard",
    clearOverdue_other: "Traiter les {{count}} interventions en retard",
    clearOverdue_many: "Traiter les {{count}} interventions en retard",
    fillDetails: "Compléter les informations manquantes",
    fillSiteDetails: "Compléter les informations manquantes du site",
    inspect: "Inspecter {{name}}",
    inspectRest_one: "Inspecter le seul actif non inspecté cette année",
    inspectRest_other: "Inspecter les {{count}} actifs non inspectés cette année",
    inspectRest_many: "Inspecter les {{count}} actifs non inspectés cette année",
    overdueChecks_one: "Effectuer le contrôle en retard",
    overdueChecks_other: "Effectuer les {{count}} contrôles en retard",
    overdueChecks_many: "Effectuer les {{count}} contrôles en retard",
    renewExpired_one: "Renouveler le certificat expiré",
    renewExpired_other: "Renouveler les {{count}} certificats expirés",
    renewExpired_many: "Renouveler les {{count}} certificats expirés",
    renewExpiring_one: "Renouveler le certificat qui expire bientôt",
    renewExpiring_other: "Renouveler les {{count}} certificats qui expirent bientôt",
    renewExpiring_many: "Renouveler les {{count}} certificats qui expirent bientôt",
    repeatFault: "Trouver la cause de « {{item}} »",
    reviewRisk: "Revoir le risque de {{name}}",
    rework: "Parler aux prestataires des travaux renvoyés",
  },
  why: {
    pastLife: "Sa durée de vie prévue est dépassée.",
    spendHigh: "Un an de réparations a coûté la moitié ou plus d'un neuf.",
    backup: "D'autres actifs en dépendent sans solution de secours.",
    clearOverdue: "Les interventions en retard laissent des problèmes connus sans solution.",
    fillDetails: "La qualité des données est de {{score}} sur 100, ce qui limite ce que le rapport peut dire.",
    neverInspected: "Son état reste inconnu tant que personne ne l'a examiné.",
    overdueChecks: "Des contrôles planifiés ont dépassé leur date.",
    renewExpired: "Un certificat expiré peut rendre son utilisation illégale ou non assurée.",
    renewExpiring: "Renouveler avant l'échéance évite une interruption de couverture.",
    repeatFault_one: "Il a déjà nécessité une intervention.",
    repeatFault_other: "Il a nécessité une intervention {{count}} fois.",
    repeatFault_many: "Il a nécessité une intervention {{count}} fois.",
    reviewRisk: "Son risque est {{level}}.",
    rework_one: "Une intervention a été renvoyée.",
    rework_other: "{{count}} interventions ont été renvoyées.",
    rework_many: "{{count}} interventions ont été renvoyées.",
  },
  jobTitle: {
    planReplacement: "Planifier le remplacement",
    findCause: "Trouver la cause du défaut récurrent : {{item}}",
    renewCertificates: "Renouveler les certificats expirés",
    riskReview: "Revue des risques",
  },
  getMore: {
    addValue: "Indiquez sa date d'installation, sa durée de vie prévue et son coût de remplacement pour que le rapport montre sa vie et sa valeur.",
    addValueButton: "Ajouter valeur et durée de vie",
    addDetails: "Complétez les informations manquantes pour améliorer la qualité des données et la fiabilité de chaque section.",
    addDetailsButton: "Modifier l'actif",
    addSiteDetails: "Complétez les informations manquantes du site pour améliorer la qualité des données.",
    addSiteDetailsButton: "Modifier le site",
    groupRule: "Créez une règle de groupe pour que les actifs similaires reçoivent automatiquement les bons contrôles.",
    groupRuleButton: "Ouvrir les règles de groupe",
    inviteContractor: "Invitez vos prestataires pour que leurs travaux soient enregistrés avec des preuves.",
    inviteContractorButton: "Inviter un prestataire",
    linkAssets: "Reliez-le aux actifs dont il dépend ou qu'il alimente, pour faire apparaître les risques en cascade.",
    linkAssetsButton: "Ajouter des liens",
    placeAssets: "Rangez les actifs du site dans des bâtiments et des zones pour voir les problèmes par emplacement.",
    placeAssetsButton: "Ouvrir le site",
    placeOnSite: "Rattachez-le à un site pour que le rapport puisse décrire son environnement.",
    placeOnSiteButton: "Choisir un site",
    scheduleInspection: "Planifiez une inspection pour connaître son état.",
    scheduleInspectionButton: "Planifier une inspection",
    siteAddress: "Ajoutez l'adresse ou la position sur la carte du site.",
    siteAddressButton: "Ajouter l'adresse",
    uploadCertificate: "Téléversez ses certificats pour pouvoir justifier la conformité.",
    uploadCertificateButton: "Téléverser un document",
  },
  coverage: {
    asset: {
      site: "un site",
      place: "son emplacement",
      links: "des liens avec d'autres actifs",
      documents: "des documents",
      inspection: "une inspection cette année",
      risk: "une évaluation des risques",
      criticality: "la criticité",
      figures: "des chiffres nocturnes",
      work: "un historique d'interventions",
      schedule: "des contrôles planifiés",
    },
    site: {
      address: "une adresse ou une position sur la carte",
      summary: "une synthèse nocturne",
      areas: "des bâtiments et des zones",
      inspected: "des inspections pour presque tous les actifs",
      assessed: "des évaluations des risques pour presque tous les actifs",
      evidence: "des preuves pour presque tous les actifs",
      contractors: "des travaux de prestataires",
      located: "la position des actifs sur la carte",
    },
  },
  gaps: {
    missingField: "Aucune valeur pour {{field}}.",
    neverInspected: "Jamais inspecté, son état actuel est donc inconnu.",
    inspectedLongAgo: "Dernière inspection il y a {{days}} jours, son état a donc pu changer.",
    noInspectionThisYear: "Aucune inspection terminée au cours des 12 derniers mois.",
    noDocuments: "Aucun document (certificats, manuels, garanties) enregistré.",
    noPhotos: "Aucune photo.",
    noRiskAssessment: "Aucune évaluation des risques n'a été réalisée.",
    noSite: "Rattaché à aucun site, son environnement ne peut donc pas être décrit.",
    noLocation: "Aucune position sur la carte.",
    noLinks: "Relié à aucun actif connexe, les effets en cascade sont donc inconnus.",
    retiredWithOpenJobs_one: "Marqué {{status}} mais a encore {{count}} intervention ouverte.",
    retiredWithOpenJobs_other: "Marqué {{status}} mais a encore {{count}} interventions ouvertes.",
    retiredWithOpenJobs_many: "Marqué {{status}} mais a encore {{count}} interventions ouvertes.",
    riskWithoutCriticality: "A un score de risque mais pas de criticité, le score repose donc sur une valeur par défaut.",
    zonesWithoutSite: "A des zones mais pas de site, les zones ne sont donc rattachées à rien.",
    noStoredFigures: "Pas encore de chiffres quotidiens enregistrés, les tendances ne peuvent donc pas être affichées.",
    staleFigures: "Les chiffres quotidiens enregistrés datent de {{days}} jours.",
    missingFieldOnAssets_one: "Aucune valeur pour {{field}} sur {{count}} actif sur {{total}}.",
    missingFieldOnAssets_other: "Aucune valeur pour {{field}} sur {{count}} actifs sur {{total}}.",
    missingFieldOnAssets_many: "Aucune valeur pour {{field}} sur {{count}} actifs sur {{total}}.",
    noAssets: "Aucun actif sur ce site.",
    assetsNotInspected_one: "{{count}} actif sur {{total}} n'a pas été inspecté au cours des 12 derniers mois.",
    assetsNotInspected_other: "{{count}} actifs sur {{total}} n'ont pas été inspectés au cours des 12 derniers mois.",
    assetsNotInspected_many: "{{count}} actifs sur {{total}} n'ont pas été inspectés au cours des 12 derniers mois.",
    noInspectionHistory: "Aucun historique d'inspection n'est encore synthétisé pour ce site.",
    assetsWithNothing_one: "Un actif n'a aucune donnée enregistrée.",
    assetsWithNothing_other: "{{count}} actifs n'ont aucune donnée enregistrée.",
    assetsWithNothing_many: "{{count}} actifs n'ont aucune donnée enregistrée.",
    assetsNotAssessed_one: "Un actif n'a pas d'évaluation des risques.",
    assetsNotAssessed_other: "{{count}} actifs n'ont pas d'évaluation des risques.",
    assetsNotAssessed_many: "{{count}} actifs n'ont pas d'évaluation des risques.",
    siteNotLocated: "Le site n'a ni adresse ni position sur la carte.",
    assetsNotLocated_one: "{{count}} actif sur {{total}} n'a pas de position sur la carte.",
    assetsNotLocated_other: "{{count}} actifs sur {{total}} n'ont pas de position sur la carte.",
    assetsNotLocated_many: "{{count}} actifs sur {{total}} n'ont pas de position sur la carte.",
    noSiteSummary: "Pas encore de synthèse du site enregistrée, les tendances ne peuvent donc pas être affichées.",
    staleSiteSummary: "La synthèse du site enregistrée date de {{days}} jours.",
    assetCountMoved_one: "Le site compte maintenant {{count}} actif, mais la synthèse de la nuit dernière en comptait {{summarised}}.",
    assetCountMoved_other: "Le site compte maintenant {{count}} actifs, mais la synthèse de la nuit dernière en comptait {{summarised}}.",
    assetCountMoved_many: "Le site compte maintenant {{count}} actifs, mais la synthèse de la nuit dernière en comptait {{summarised}}.",
    assetsRiskWithoutCriticality_one: "Un actif a un score de risque mais pas de criticité.",
    assetsRiskWithoutCriticality_other: "{{count}} actifs ont un score de risque mais pas de criticité.",
    assetsRiskWithoutCriticality_many: "{{count}} actifs ont un score de risque mais pas de criticité.",
  },
  versions: {
    title: "Versions",
    hint: "Chaque version enregistrée reste exactement telle qu’elle était. Ouvrez-en une pour la lire ou la comparer à la précédente.",
    none: "Aucune version enregistrée. Enregistrez cette version, ou faites rédiger la version IA, pour commencer la liste.",
    save: "Enregistrer cette version",
    saveFailed: "Impossible d’enregistrer la version",
    savedTitle: "Enregistrée",
    savedBody: "Enregistrée comme version {{version}}.",
    label: "Version {{version}} · {{date}}",
    ai: "Rédigée par l’IA",
    app: "Les chiffres de l’application",
    open: "Ouvrir",
    close: "Fermer",
    viewing: "Vous lisez la version {{version}}, enregistrée le {{date}}.",
    backToCurrent: "Revenir au rapport actuel",
  },
  compare: {
    title: "Ce qui a changé entre la version {{older}} et la version {{newer}}",
    show: "Comparer avec la version {{version}}",
    hide: "Masquer la comparaison",
    verdict: "Avis général : {{before}} → {{after}} ({{movement}})",
    dataQuality: "Qualité des données : {{before}} → {{after}} ({{movement}})",
    figure: "{{before}} → {{after}} ({{movement}})",
    actionsAdded: "Nouvelles actions : {{n}}",
    actionsGone: "Actions plus nécessaires : {{n}}",
    bullet: "• {{text}}",
    movement: {
      better: "mieux",
      worse: "moins bien",
      same: "sans changement",
      new: "nouveau",
      gone: "plus affiché",
    },
  },
  share: {
    open: "Partager",
    title: "Partager ce rapport",
    hint: "La personne est prévenue dans l’application et par e-mail. Le lien ouvre le rapport dans AssetWRX : la couverture et le tableau de bord tout de suite, le reste après connexion ou création d’un compte gratuit.",
    toLabel: "Envoyer à",
    toPlaceholder: "Rechercher un contact ou saisir une adresse e-mail",
    messageLabel: "Message (facultatif)",
    messagePlaceholder: "Ajouter une note pour le destinataire...",
    savesFirst: "Ce qui est à l’écran est d’abord enregistré comme nouvelle version, pour qu’elle lise exactement ceci.",
    send: "Envoyer le rapport",
    sentTitle: "Partagé",
    sentBody: "La version {{version}} a été partagée avec {{who}}.",
    failedTitle: "Partage impossible",
    failedBody: "Un problème est survenu. Réessayez.",
    sharedWith: "Partagé avec",
    versionOn: "Version {{version}} · {{date}}",
    read: "Lu le {{date}}",
    notRead: "Pas encore lu",
    withdrawn: "Retiré",
    replaced: "Remplacé par une version plus récente",
    sendNew: "Envoyer la version {{version}}",
    withdraw: "Retirer",
    close: "Fermer",
  },
  download: {
    pdf: "Télécharger le PDF",
    csv: "Télécharger le CSV",
    approverOnly: "Le téléchargement est réservé aux personnes qui approuvent les travaux sur cet actif. Utilisez Partager pour l’envoyer à quelqu’un.",
  },
  csv: {
    similarMiddle: "Milieu des similaires",
    basis: "Base",
    part: "Partie",
    item: "Élément",
    value: "Valeur",
    band: "Évaluation",
    note: "Remarque",
    subject: "Objet",
    version: "Version",
    written: "Rédigé",
    reader: "Rédigé pour",
  },
  shared: {
    header: "Rapport partagé",
    loadFailed: "Le rapport n’a pas pu être chargé.",
    notFound: "Ce lien ne mène à aucun rapport.",
    goToApp: "Aller sur AssetWRX",
    revoked: "Ce rapport n’est plus partagé avec vous.",
    replaced: "Une version plus récente de ce rapport a été partagée avec vous.",
    openNewer: "Ouvrir la version plus récente",
    notYours: "Ce rapport a été partagé avec quelqu’un d’autre. Connectez-vous avec l’adresse à laquelle il a été envoyé.",
    verdict: "Avis général : {{rating}}",
    gateTitle: "Lire tout le rapport",
    gateBody: "Connectez-vous, ou créez un compte gratuit, pour lire toutes les sections, le plan d’action et la qualité des données.",
    signIn: "Se connecter",
    createAccount: "Créer un compte gratuit",
    sharedBy: "Partagé par {{who}} le {{date}}",
    sharedOn: "Partagé le {{date}}",
    note: "Son message : {{message}}",
    newerExists: "Il existe une version plus récente (version {{version}}). Demandez-la à l’expéditeur si besoin.",
    readOnly: "Lecture seule. Ce rapport reste tel qu’il était lors du partage.",
  },
  comparison: {
    title: "En comparaison",
    measure: {
      compliance: "Conformité",
      condition: "État",
      risk: "Risque",
      right_first_time: "Bon du premier coup",
    },
    position: {
      better: "mieux que la plupart",
      similar: "comme la plupart",
      worse: "derrière la plupart",
    },
    row: "{{value}}, {{position}} (milieu des similaires : {{middle}})",
    notEnough: "Trop peu de similaires ont ce chiffre pour comparer.",
    basis: {
      asset_one: "Comparé à 1 équipement similaire que vous voyez, sur les chiffres de la nuit dernière.",
      asset_other: "Comparé à {{count}} équipements similaires que vous voyez, sur les chiffres de la nuit dernière.",
      asset_many: "Comparé à {{count}} équipements similaires que vous voyez, sur les chiffres de la nuit dernière.",
      site_one: "Comparé à 1 autre site que vous voyez, sur les chiffres de la nuit dernière.",
      site_other: "Comparé à {{count}} autres sites que vous voyez, sur les chiffres de la nuit dernière.",
      site_many: "Comparé à {{count}} autres sites que vous voyez, sur les chiffres de la nuit dernière.",
    },
    finding: {
      behind: "Derrière la plupart des similaires pour {{measure}}.",
      ahead: "Devant la plupart des similaires pour {{measure}}.",
      inLine: "Dans la moyenne des similaires.",
    },
  },
  value: {
    title: "Valeur et durée de vie",
    measure: {
      installed_on: "Installé le",
      age: "Âge",
      expected_life: "Durée de vie prévue",
      remaining_life: "Durée de vie restante",
      purchase_cost: "Coût d'achat",
      replacement_cost: "Coût de remplacement",
      spend: "Dépensé en travaux",
      spend_share: "Dépenses par rapport au coût de remplacement",
      replacement_total: "Valeur de remplacement enregistrée",
      assets_with_value: "Équipements avec un coût de remplacement",
      past_life: "Équipements au-delà de leur durée de vie",
    },
    years_one: "{{value}} an",
    years_other: "{{value}} ans",
    years_many: "{{value}} ans",
    lifeUsed: "{{pct}} % de sa durée de vie prévue utilisée",
    finding: {
      pastLife: "Sa durée de vie prévue est dépassée de {{years}} ans.",
      spendHigh: "Un an de travaux a coûté {{pct}} % de son remplacement. Remplacer peut coûter moins que réparer.",
      nearEnd: "Il a utilisé {{pct}} % de sa durée de vie prévue.",
      lifeLeft: "Il reste environ {{years}} ans de durée de vie prévue.",
      recorded: "Ce qui est enregistré sur sa valeur.",
      sitePastLife_one: "1 équipement sur {{of}} avec une durée de vie enregistrée l'a dépassée.",
      sitePastLife_other: "{{count}} équipements sur {{of}} avec une durée de vie enregistrée l'ont dépassée.",
      sitePastLife_many: "{{count}} équipements sur {{of}} avec une durée de vie enregistrée l'ont dépassée.",
      siteRecorded_one: "1 équipement sur {{of}} a un coût de remplacement enregistré.",
      siteRecorded_other: "{{count}} équipements sur {{of}} ont un coût de remplacement enregistré.",
      siteRecorded_many: "{{count}} équipements sur {{of}} ont un coût de remplacement enregistré.",
      siteSpendOnly: "Ce qu'ont coûté les travaux du site.",
    },
    spendBasis: {
      year: "Dépenses des 12 derniers mois, d'après {{withCost}} des {{jobs}} travaux terminés qui ont un coût.",
      ninetyDays: "Dépenses des 90 derniers jours, d'après {{withCost}} des {{jobs}} travaux terminés qui ont un coût.",
    },
    marketTitle: "Prix courant du marché",
    marketHint: "Issu de sources en ligne, non vérifié par AssetWRX.",
  },
esg: {
section: "Énergie, carbone et développement durable (ESG)",
basis: "D'après les relevés de compteurs des 24 derniers mois, les fluides frigorigènes et certificats énergétiques enregistrés et les facteurs carbone du gouvernement britannique ({{year}}). Le carbone est une estimation.",
ratingsTable: "Certificats énergétiques",
col: {
certificate: "Certificat",
rating: "Classe",
},
finding: {
belowMinimum: "Certificats énergétiques sous le minimum de location (E) : {{n}}.",
fgasOverdue: "Contrôles d'étanchéité des gaz fluorés en retard : {{n}}.",
noMeters: "Aucun compteur d'énergie n'est enregistré : l'énergie et le carbone ne peuvent pas être mesurés.",
energyChange: "{{kwh}} kWh consommés sur les 12 derniers mois ({{change}} % par rapport à l'année précédente), environ {{tonnes}} t CO₂e.",
energy: "{{kwh}} kWh consommés sur les 12 derniers mois, environ {{tonnes}} t CO₂e.",
},
meaning: {
belowMinimum: "En Angleterre et au pays de Galles, un bâtiment ne peut pas être loué sous E sans dérogation. Planifiez l'amélioration ou enregistrez une dérogation.",
fgasOverdue: "Des contrôles en retard enfreignent les règles sur les gaz fluorés et laissent fuir du fluide, un puissant gaz à effet de serre.",
noMeters: "Sans compteurs, la consommation et le carbone sont inconnus. Ajoutez des compteurs et faites des relevés.",
noFloorArea: "Ajoutez la surface pour comparer la consommation par m² avec d'autres bâtiments.",
ok: "L'énergie et le carbone sont mesurés. Gardez des relevés réguliers pour que les chiffres restent complets.",
},
stat: {
energy: "Énergie, kWh (12 mois)",
change: "Évolution annuelle, %",
intensity: "kWh par m²",
carbon: "Carbone, t CO₂e",
scope1: "Scope 1, t éq. CO₂",
scope2: "Scope 2, t éq. CO₂",
water: "Eau, m³",
meters: "Compteurs relevés",
refrigerant: "Fluide frigorigène, t CO₂e",
fgasOverdue: "Contrôles gaz F en retard",
},
status: {
belowMinimum: "Sous le minimum de location",
expired: "Expiré",
expiresSoon: "Expire dans moins de 6 mois",
valid: "Valide",
},
action: {
improveEpc: "Planifier des travaux pour porter la classe énergétique à E ou mieux",
fgasOverdue: "Réaliser les contrôles d'étanchéité en retard ({{n}})",
renewEpc: "Renouveler le certificat énergétique expiré",
readMeters: "Relever les compteurs sans relevé depuis 3 mois ({{n}})",
},
why: {
improveEpc: "Sous E, il ne peut pas être loué légalement sans dérogation.",
fgasOverdue: "Les contrôles d'étanchéité sont obligatoires pour cette quantité de fluide.",
renewEpc: "Un certificat énergétique est nécessaire pour vendre ou louer.",
readMeters: "Des relevés manquants rendent les chiffres d'énergie et de carbone incomplets.",
},
jobTitle: {
improveEpc: "Travaux d'amélioration de la classe énergétique",
renewEpc: "Renouveler le certificat de performance énergétique",
},
},
};
